export const QueryKeys = {
	ListOfObjects: 'ListOfObjects',
	ListOfMessage: 'ListOfMessage',
	ListOfRequests: 'ListOfRequests',

	Lootboxes: 'Lootboxes',

	Activities: 'Activities',
	CoinflipActivities: 'CoinflipActivities',
	LootboxActivities: 'LootboxActivities',
	LimboActivities: 'LimboActivities',
	DiceActivities: 'DiceActivities',
	PlinkoActivities: 'PlinkoActivities',
	SuiroyaleActivities: 'SuiroyaleActivities',

	RemainingGifts: 'RemainingGifts',
	RemainingGiftsPerIP: 'RemainingGiftsPerIP',

	NftFactory: 'NftFactory',
	OwnedNft: 'OwnedNft',
	NameServer: 'NameServer',
	Balance: 'Balance',
	WalletBalances: 'WalletBalances',

	RefereeRewards: 'RefereeRewards',
	ReferrerRewards: 'ReferrerRewards',
	IsReferred: 'IsReferred',

	// VIP related queries
	VipProfile: 'VipProfile',
	VipUnclaimedRewards: 'VipUnclaimedRewards',
	VipExpMultipliers: 'VipExpMultipliers',
	WeeklyContest: 'WeeklyContest',

	Price: 'Price',
	AllQuests: 'AllQuests',
	FlowxCoins: 'FlowxCoins',
	CoinMetadata: 'CoinMetadata',

	// Homepage stats
	GameStats: 'GameStats',
	TopActivities: 'TopActivities',
	TopActivitiesByGame: 'TopActivitiesByGame',
	ReferenceGasPrice: 'ReferenceGasPrice',
} as const;
